import { render, staticRenderFns } from "./NuevaConstanciaUsoSuelo.vue?vue&type=template&id=bf2f3f46&"
import script from "./NuevaConstanciaUsoSuelo.vue?vue&type=script&lang=ts&"
export * from "./NuevaConstanciaUsoSuelo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports